declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

export function pushGtmEvent(payload: Record<string, unknown> & { event: string }): void {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
}

// userId must be the Cognito `sub` of a genuinely authenticated user; pass
// undefined on logout so stale values don't leak into a later session.
export function setGtmUserId(userId: string | undefined): void {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ user_id: userId });
}
